import { FontLoader } from "./FontLoader"

let fontPhase: 'none' | 'loading' | 'loaded' = 'none'
let pendingRequests: (() => void)[] = []
let pendingProgresses: ((progress: number, total: number) => void)[] = []
let fontLoadProgress: number = 0

/**
 * 谱面字体加载清单 —— 现在只剩**音符符号与西文**，合计 ~1MB。
 *
 * 中文文本的三个大字体（CommonSerif 7.5MB / CommonLight 4.4MB / CommonBlack 2.1MB，
 * 连同其 bold 变体合计 ~15MB）**不再加载**：FontMetric 里把这三个 family
 * 别名到站点 UI 已自托管的 'SBT Serif' / 'SBT Sans' 子集字体上（动态歌词
 * 逐字回退系统字体），字形与站点视觉风格一致，打开乐谱的字体等待从分钟级
 * 降到秒级。别名表见 `renderer/FontMetric.ts`。
 *
 * 若将来要恢复专用字体（比如出版级排版），把下面注释的三行放开即可。
 */
type FontEntry = {
	family: string
	name: string
	format: string
	weight?: string
	asc?: number
	desc?: number
}

const fonts: FontEntry[] = [
	// { family: 'CommonLight', name: 'noto_sans_sc_light', format: 'woff2', asc: undefined, desc: undefined },
	// { family: 'CommonLight', name: 'noto_sans_sc_light', format: 'woff2', weight: 'bold', asc: undefined, desc: undefined },
	// { family: 'CommonSerif', name: 'uming_cn_dotfix', format: 'woff2' },
	// { family: 'CommonSerif', name: 'uming_cn_dotfix', format: 'woff2', weight: 'bold' },
	// { family: 'CommonBlack', name: 'wqy_microhei', format: 'woff2' },
	{ family: 'Roman', name: 'roman', format: 'woff2' },
	{ family: 'Roman', name: 'roman', format: 'woff2', weight: 'bold' },
	{ family: 'RomanItalic', name: 'roman_italic', format: 'woff2' },
	{ family: 'SparksNMN-EOPNumber', name: 'eop_number', format: 'ttf' },
	{ family: 'SparksNMN-mscore-20', name: 'mscore-20', format: 'ttf' },
	{ family: 'SparksNMN-Bravura', name: 'bravura', format: 'woff' },
]

const tasksRaw = fonts.map(font => ({
	name: font.family,
	url: `${font.name}/${font.name}${font.weight ? ('-transformed-' + font.weight) : ''}.${font.format}`,
	weight: font.weight ?? 'normal',
	asc: font.asc,
	desc: font.desc,
}))

export module FontLoaderProxy {
	export function getState() {
		return fontPhase
	}
	export function requestFontLoad(fontStatic: string, callback?: () => void, progressCallback?: (progress: number, total: number) => void) {
		const totalCount = fonts.length

		progressCallback && progressCallback(fontLoadProgress, totalCount)
		if(fontPhase == 'loaded') {
			callback && callback()
			return
		}
		if(fontPhase == 'none') {
			const tasks = tasksRaw.map(task => ({
				...task,
				url: fontStatic + '/' + task.url,
				weight: task.weight
			}))
			FontLoader.loadFonts(tasks, () => {
				fontPhase = 'loaded'
				pendingRequests.forEach(func => func())
				pendingRequests = []
			}, () => {
				fontLoadProgress += 1
				pendingProgresses.forEach(func => func(fontLoadProgress, totalCount))
				if(fontLoadProgress == totalCount) {
					pendingProgresses = []
				}
			})
			fontPhase = 'loading'
		}
		callback && pendingRequests.push(callback)
		progressCallback && pendingProgresses.push(progressCallback)
	}
}
